import _template from "lodash/template";
import { common } from "../../Organisms/Translations/fallback/common";

export function getPaginationResult(
  page: number,
  itemPerPage: number,
  max: number,
  overrides?: Record<string, number>
) {
  if (max === 0) return "";

  const template = _template(common.pagination.showingOfTemplate);

  const defaults = {
    start: (page - 1) * itemPerPage + 1,
    end: Math.min(max, page * itemPerPage),
    max: max,
  };

  return template({
    ...defaults,
    ...overrides,
  });
}
